import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Message, Box, Text, Divider, IconSvg, Icon } from "samba-ui";
import styled from "styled-components";
import {
  Banner,
  ClientName,
  StyledClientDetail,
  ClientDetailContent,
  RightNav,
  Action,
  MainContent,
  FeedHeaderContainer,
  ActiveFeedHeader,
  InactiveFeedHeader
} from "./styles";
import { GenerateAdHocFileIcon, CreateFeedIcon } from "../../icons";
import { updateClient, updateClientServiceStop } from "../../actions/client";
import {
  selectAllFeeds,
  getAllActiveFeedsByClient,
  getAllInactiveFeedsByClient
} from "../../selectors";
import TabView from "../Common/TabView";
import CreateFeedModal from "./../Common/CreateFeedModal";
import { fetchFeeds, createFeed } from "../../actions/feed";
import ServiceStopUpdateModal, {
  CLIENT
} from "../Common/ServiceStopUpdateModal";
import { getStartOfToday } from "../../utils";
import CreateClientModal from "../Home/CreateClientModal";
import SendCredentialsViaEmailModal from "../Common/SendCredentialsViaEmailModal";
import { GET_PARAMS } from "../../actions/paramHelper";

export const SERVICE_STOP_UPDATE_MODAL = "SERVICE_STOP_UPDATE_MODAL";
export const CREATE_FEED_MODAL = "CREATE_FEED_MODAL";
export const UPDATE_CLIENT_MODAL = "UPDATE_CLIENT_MODAL";

const StyledIcon = styled(Icon)`
  margin-right: 16px;
`;

const StyledIconSvg = styled(IconSvg)`
  margin-right: 12px !important;
`;

const defaultState = {
  show: null,
  action: null,
  isSample: null,
  isEmailModalOpen: false,
  emailMessage: {}
};

export class ClientDetail extends Component {
  state = {
    ...defaultState
  };

  onSubmit = this.onSubmit.bind(this);
  handleClientSubmit = this.handleClientSubmit.bind(this);
  onSendEmailClick = this.onSendEmailClick.bind(this);
  sendEmailToClient = this.sendEmailToClient.bind(this);

  getDownloadHref(clientId) {
    const getUrl = window.location;
    let baseUrl = `${getUrl.protocol}//${getUrl.host}`;
    baseUrl = baseUrl.replace("3000", "8080");
    return `${baseUrl}/api/clients/${clientId}/credentials`;
  }

  onSubmit(selectedServiceStop) {
    const { client, updateClientServiceStop, fetchFeeds } = this.props;

    const isStopped =
      client.service_stop && new Date(client.service_stop) < new Date();

    // If the client is stopped, then we need to set the service_stop
    // to the date in the future that the user selected in the ServiceStopUpdateModal
    // confirmation modal (i.e. newServiceStop param).
    // Otherwise we set the service_stop to the start of today so the
    // client will be stopped moving forward until restarted
    const newServiceStop = isStopped ? selectedServiceStop : getStartOfToday();

    return updateClientServiceStop(client.id, newServiceStop).then(
      dispatchedAction => {
        // Now fetch feeds so they statuses are up to date
        // and keep the ServiceStopUpdateModal displayed so
        // the success message will show
        fetchFeeds();
        return dispatchedAction;
      }
    );
  }

  handleClientSubmit(body) {
    const { client } = this.props;
    return this.props.updateClient(client.id, body).then(action => {
      // Return action so any other function chaining a .then to
      // handleClientSubmit also has access to it
      return action;
    });
  }

  onSendEmailClick() {
    this.setState({ isEmailModalOpen: true });
  }

  async sendEmailToClient(email) {
    const {
      client: { id }
    } = this.props;
    const res = await fetch(
      `/api/clients/${id}/sendEmail?email=${email}`,
      GET_PARAMS()
    );
    const data = await res.json();
    this.setState({
      isEmailModalOpen: false,
      emailMessage: {
        success: data.success,
        message: data.success ? "Email successfully sent!" : data.error
      }
    });

    setTimeout(() => {
      this.setState({ emailMessage: {} });
    }, 3000);
  }

  render() {
    const {
      action,
      show,
      isSample,
      isEmailModalOpen,
      emailMessage
    } = this.state;
    const { client, feeds, currentUser } = this.props;
    if (!client) return null;

    const activeFeeds = getAllActiveFeedsByClient(feeds, client.id);
    const inactiveFeeds = getAllInactiveFeedsByClient(feeds, client.id);

    return (
      <StyledClientDetail>
        <Banner>
          <ClientName>{client.name}</ClientName>
          <Box>
            <Text color="white" fontSize={1} fontWeight={400}>
              {client.bucket_path}
            </Text>
          </Box>
        </Banner>
        <ClientDetailContent>
          <MainContent>
            {emailMessage.message ? (
              <Message
                fontSize={1}
                mb={2}
                variant={emailMessage.success ? "success" : "alert"}
              >
                {emailMessage.message}
              </Message>
            ) : null}
            <FeedHeaderContainer>
              <ActiveFeedHeader>Active feeds</ActiveFeedHeader>
              <Divider />
            </FeedHeaderContainer>
            <TabView feeds={activeFeeds} expand />
            <FeedHeaderContainer style={{ marginTop: "60px" }}>
              <InactiveFeedHeader>Inactive feeds</InactiveFeedHeader>
              <Divider />
            </FeedHeaderContainer>
            <TabView feeds={inactiveFeeds} expand />
          </MainContent>
          <RightNav>
            <Action
              onClick={() =>
                this.setState({ show: CREATE_FEED_MODAL, isSample: false })
              }
            >
              <CreateFeedIcon fill="#5d69e6" />
              Create a feed
            </Action>
            <Action
              onClick={() =>
                this.setState({ show: CREATE_FEED_MODAL, isSample: true })
              }
            >
              <GenerateAdHocFileIcon fill="#5d69e6" />
              Generate adhoc file
            </Action>
            {currentUser.isAdmin ? (
              <Action onClick={this.onSendEmailClick}>
                <StyledIcon name="envelope fa-lg" />
                Email the AWS credentials
              </Action>
            ) : null}
            <Action
              onClick={() => this.setState({ show: UPDATE_CLIENT_MODAL })}
            >
              <StyledIconSvg name="company-manager" />
              Settings
            </Action>
          </RightNav>
        </ClientDetailContent>
        <CreateFeedModal
          show={show === CREATE_FEED_MODAL}
          onDismiss={() => this.setState({ ...defaultState })}
          onSubmit={feed => this.props.createFeed(feed)}
          isSample={isSample}
          clientId={client.id}
        />
        <ServiceStopUpdateModal
          show={show === SERVICE_STOP_UPDATE_MODAL}
          onDismiss={() => this.setState({ ...defaultState })}
          item={client}
          type={CLIENT}
          action={action}
          onSubmit={this.onSubmit}
        />
        <CreateClientModal
          show={show === UPDATE_CLIENT_MODAL}
          onDismiss={() => this.setState({ ...defaultState })}
          onSubmit={this.handleClientSubmit}
          client={client}
        />
        <SendCredentialsViaEmailModal
          show={isEmailModalOpen}
          onDismiss={() => this.setState({ isEmailModalOpen: false })}
          onSubmit={this.sendEmailToClient}
        />
      </StyledClientDetail>
    );
  }
}

ClientDetail.propTypes = {
  currentUser: PropTypes.shape({
    displayName: PropTypes.string,
    avatar: PropTypes.string,
    company: PropTypes.string
  }).isRequired,
  client: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  feeds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      client_id: PropTypes.number,
      created_at: PropTypes.string,
      delivery_schedule: PropTypes.string,
      kantar_filter_expression: PropTypes.shape({
        brand: PropTypes.arrayOf(PropTypes.string)
      }),
      name: PropTypes.string,
      pdp_external_partner: PropTypes.string,
      progress_ids: PropTypes.arrayOf(PropTypes.string),
      quality_metrics: PropTypes.shape({
        final_rowcount: PropTypes.number
      }),
      service_start: PropTypes.string,
      status: PropTypes.string,
      updated_at: PropTypes.string
    })
  ),
  updateClientServiceStop: PropTypes.func,
  updateClient: PropTypes.func,
  fetchFeeds: PropTypes.func,
  createFeed: PropTypes.func
};

export default withRouter(
  connect(
    (store, props) => {
      const currentUser = store.currentUser;
      const clientId = props.match.params.clientId;
      const client = store.entities.clients.byId[clientId];
      return {
        client,
        currentUser,
        feeds: selectAllFeeds(store)
      };
    },
    { updateClient, updateClientServiceStop, fetchFeeds, createFeed }
  )(ClientDetail)
);
